<template>
  <div class="mt-3">
    <div class="sub-title">Afleveradres</div>

    <div class="card card-body bg-light">
      <div class="row">
        <div class="col-md-8">
          <template v-if="loadingQuotationDetails">
            <font-awesome-icon class="font-awesome-icon" icon="spinner" spin/>
          </template>
          <template v-else>
            {{ deliveryAddress.name }}<br/>
            {{ deliveryAddress.address }}<br/>
            {{ deliveryAddress.postcode }} {{ deliveryAddress.city }}
          </template>
        </div>
        <div class="col-md-5 float-right">
          <div @click="showModal" class="link">Wijzig</div>
        </div>
      </div>
    </div>

    <b-modal id="delivery-address-details-modal" ref="delivery-address-details-modal" size="sm">
      <template slot="modal-header">
        <h4 class="modal-title">Afleveradres wijzigen</h4>
        <button type="button" aria-label="Close" @click="hideModal" class="close">
          <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
        </button>
      </template>
      <template slot="default">
        <form @submit.prevent="onSubmit">
          <div class="form-row">
            <div class="col-md-13">
              <label for="address" class="col-form-label">Adres</label>
              <input
                id="address"
                name="address"
                type="text"
                class="form-control"
                :class="{'is-invalid': $v.address.$error}"
                v-model="address"
                @blur="$v.address.$touch()"
                placeholder="Adres"
              >
              <span v-if="$v.address.$error" class="invalid-feedback" role="alert">
                <strong>Vul a.u.b. het adres in.</strong>
              </span>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-5">
              <label for="postcode" class="col-form-label">Postcode</label>
              <input
                id="postcode"
                name="postcode"
                type="text"
                class="form-control"
                :class="{'is-invalid': $v.postcode.$error}"
                v-model="postcode"
                @blur="$v.postcode.$touch()"
                placeholder="1234AB"
              >
              <span v-if="$v.postcode.$error" class="invalid-feedback" role="alert">
                <strong>Vul a.u.b. de postcode in.</strong>
              </span>
            </div>
            <div class="col-md-8">
              <label for="city" class="col-form-label">Plaats</label>
              <input
                id="city"
                name="city"
                type="text"
                class="form-control"
                :class="{'is-invalid': $v.city.$error}"
                v-model="city"
                @blur="$v.city.$touch()"
                placeholder="Plaats"
              >
              <span v-if="$v.city.$error" class="invalid-feedback" role="alert">
                <strong>Vul a.u.b. de plaats in.</strong>
              </span>
            </div>
          </div>
        </form>
      </template>
      <template slot="modal-footer">
        <button
          @click="saveDetails"
          type="button"
          :disabled="$v.$invalid"
          :class="{'disabled cursor-not-allowed': $v.$invalid}"
          class="btn btn-oldevuuren btn-round w-100">
          Afleveradres opslaan
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { UPDATE_DELIVERY_DETAILS } from '../../store/types'
  import { minLength, required } from 'vuelidate/lib/validators'

  export default {
    data() {
      return {
        address: null,
        postcode: null,
        city: null
      }
    },
    validations: {
      address: {
        required,
        minLen: minLength(2)
      },
      postcode: {
        required,
        minLen: minLength(6)
      },
      city: {
        required,
        minLen: minLength(6)
      }
    },
    computed: {
      loadingQuotationDetails() {
        return this.$store.getters.loadingQuotationDetails
      },
      deliveryAddress() {
        return this.$store.getters.deliveryAddress
      },
      detailsStatus() {
        return this.$store.getters.detailsStatus
      },
      detailsBusy() {
        return this.$store.getters.detailsBusy
      }
    },
    mounted() {
      this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
        this.address = this.deliveryAddress.address
        this.city = this.deliveryAddress.city
        this.postcode = this.deliveryAddress.postcode
      })
    },
    methods: {
      saveDetails() {
        const deliveryDetails = {
          address: this.address,
          postcode: this.postcode,
          city: this.city
        }

        this.$store.dispatch(UPDATE_DELIVERY_DETAILS, deliveryDetails)

        // Close our modal
        this.$refs['delivery-address-details-modal'].hide()
      },
      showModal() {
        this.$refs['delivery-address-details-modal'].show()
      },
      hideModal() {
        this.$refs['delivery-address-details-modal'].hide()
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
